import { useCallback, useEffect, useState } from "react";
import http from "../../../../http";
import Associado from "../../models/Associado";
import { useRecarregaAoRenovarToken } from "../../../shared/hooks/useRecarregaAoRenovarToken";

export const useBuscaListaCadastros = () => {

  const [listaAssociados, setListaAssociados] = useState([])

  const buscaListaCadastros = useCallback(() => {
    http.get(`/lista-associados`)
        .then(res => {
          const resposta = res.data
          const listaAssociadosCompleta = resposta.map(associado => {
            return Associado.create(associado)
          })
          
          setListaAssociados(listaAssociadosCompleta)
        })
        .catch(() => setListaAssociados([]))
  }, [])

  useEffect(() => {
    buscaListaCadastros()
  }, [buscaListaCadastros])

  useRecarregaAoRenovarToken(buscaListaCadastros)
  
    return {
      listaAssociados
    };
  };
